var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToolsets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.724 7.026A3.75 3.75 0 0 1 10.939 2.064L11.5 2.625L9.5 4.625V6.125A0.375 0.375 0 0 0 9.875 6.5H11.375L13.375 4.5L13.936 5.061A3.75 3.75 0 0 1 8.974 9.276L4.716 13.534A1.591 1.591 0 0 1 2.466 13.534A1.591 1.591 0 0 1 2.466 11.284L6.724 7.026ZM4.438 12.125A0.5625 0.5625 0 1 0 3.313 12.125A0.5625 0.5625 0 1 0 4.438 12.125Z",
    fill: "#828A8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsets);
export default __webpack_public_path__ + "static/media/toolsets.1b961e8ae72d8e3db5e403113ce365df.svg";
export { ForwardRef as ReactComponent };